var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",class:_vm.$isInEditMode ? 'pt-25' : 'h-0'},[_c('editor-tip-tap',{class:{ 'text-white': !_vm.$isInEditMode },attrs:{"name":"h1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }